import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IBranchPartner } from '../interfaces';
import { BranchPartnersMapper } from '../mappers';

export type IGetBranchPartnersRepoResponse = IRepoResponse<200, { data: IBranchPartner[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetBranchPartnersRepo = IRepo<[any], IGetBranchPartnersRepoResponse>;

export const GetBranchPartnersRepoType = Symbol.for('GetBranchPartnersRepo');

@bind(GetBranchPartnersRepoType)
export class GetBranchPartnersRepo implements IGetBranchPartnersRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/companies', query) });
      if (result.status === 200) {
        const data: IBranchPartner[] = result.data.data.map((elem) => BranchPartnersMapper.toDomain(elem));
        const total: number = result.data.total;

        return {
          status: 200 as 200,
          response: {
            data,
            total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
